import React, {useEffect, useState} from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'

import {Container} from './styles'

const propTypes = {
  dotCount: PropTypes.number,
  dotCharacter: PropTypes.string,
  interval: PropTypes.number,
}
const defaultProps = {
  dotCount: 3,
  dotCharacter: '.',
  interval: 1000,
}

type DotLoaderProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const DotLoader: React.FC<DotLoaderProps> = ({dotCount, dotCharacter, interval}) => {
  const [content, setContent] = useState({content: '', count: 0})

  useEffect(() => {
    const i = setInterval(() => {
      setContent(prevContent => {
        if (prevContent.count >= dotCount!) {
          return {
            content: '',
            count: 0,
          }
        }
        return {
          content: `${prevContent.content}${dotCharacter}`,
          count: prevContent.count + 1,
        }
      })
    }, interval!)

    return () => {
      clearInterval(i)
    }
  }, [dotCount, dotCharacter, interval])

  return <Container characters={dotCharacter!.length * dotCount!}>{content?.content}</Container>
}

DotLoader.propTypes = propTypes
DotLoader.defaultProps = defaultProps

export default React.memo(DotLoader)
